<template>
  <div class="user_content">
    <div class="user_header">
      <div class="header_box">
        <span class="goback"
              v-show="backFlag"
              @click="goBack">
          <img src="../assets/images/backpage.png"
               alt="">
        </span>
        <h3>{{title}}</h3>
        <span class="close passIconfont  close icon-ftshanchu "
              @click="close"></span>
      </div>
    </div>
    <div class="content-box">
      <router-view />
    </div>
    <!-- <div class="content-box1">
      <router-view />
    </div> -->
  </div>
</template>

<script>
import { appPostMessage } from '@/utils/communication'
export default {
  data() {
    return {
      title: '',
      backFlag: false,
    }
  },
  watch: {
    $route: function (to, from) {
      if (
        this.$route.path.indexOf('home') > -1 ||
        this.$route.path.indexOf('Scuess') > -1
      ) {
        this.backFlag = false
      } else {
        this.backFlag = true
      }
      this.title = this.$store.getters.web_title
    },
    title() {
      this.title = this.$store.getters.web_title
    },
  },
  created() {
    this.init()
    if (
      this.$route.path.indexOf('home') > -1 ||
      this.$route.path.indexOf('Scuess') > -1
    ) {
      this.backFlag = false
    } else {
      this.backFlag = true
    }
  },
  methods: {
    init() {
      this.title = this.$store.getters.web_title
    },
    goBack() {
      this.$router.go(-1)
    },
    close() {
      console.log(this.$route.path.indexOf('/logOffScuess') > -1)
      if (this.$route.path.indexOf('/logOffScuess') > -1) {
        const appmsg = { code: 8, data: '' }
        appPostMessage(appmsg)
      } else {
        const msg = { code: 1, data: '' }
        appPostMessage(msg)
      }
    },
  },
}
</script>

<style lang="less" scope>
.user_content {
  width: 100%;
  //   height: 1334/75rem;
  //   max-width: 600px;
  border-radius: 16px;
  margin: 0 auto;
  overflow: hidden;
  .user_header {
    width: 100%;
    height: 154/75rem;
    background: rgba(248, 248, 248, 0.39);
    padding-top: 80/75rem;
    box-sizing: border-box;
    position: relative;
    z-index: inherit;
    .header_box {
      position: relative;
      .goback {
        width: 40/75rem;
        height: 26/75rem;
        position: absolute;
        left: 26/75rem;
        top: 10/75rem;
      }
      .close {
        width: 96/75rem;
        height: 52/75rem;
        background: rgba(213, 213, 213, 0.08);
        border: 1px solid rgba(0, 0, 0, 0.10196078431372549);
        opacity: 1;
        border-radius: 30/75rem;
        font-size: 21/75rem;
        line-height: 52/75rem;
        text-align: center;
        position: absolute;
        right: 30/75rem;
        top: 0;
      }
      h3 {
        color: #353535;
        font-size: 36/75rem;
        font-family: 'Alibaba PuHuiTi';
        font-weight: 400;
        text-align: center;
      }
    }
  }
  .content-box {
    width: 100%;
    height: calc(100vh - 90px);
    background: #fff;
  }
  //   .content-box1 {
  //     width: 100%;

  //     background: #fff;
  //   }
}
</style>